export default __webpack_public_path__ + "static/media/330_business01-fr-mobile.43b810e1.png";